<template>
    <div class="sitemap-section">
        <label>
            <VJoyLink :href="$withLocalePrefix(family.url)">{{ family.familyLabel }}</VJoyLink>
        </label>
        <ul>
            <li v-for="category in family.categorySitemapEntries" :key="category.categoryId">
                <VJoyLink :href="$withLocalePrefix(category.url)">{{ category.categoryLabel }}</VJoyLink>
                <ul>
                    <li v-for="job in category.jobSitemapEntries" :key="job.jobId">
                        <VJoyLink v-if="job.url" :href="$withLocalePrefix(job.url)">{{ job.jobLabel }}</VJoyLink>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
    import type {FamilySitemapEntry} from '@api/models';
    import {VJoyLink} from '@maltjoy/core-vue';

    defineProps<{family: FamilySitemapEntry}>();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    .sitemap-section {
        padding: var(--joy-core-spacing-5) 0 var(--joy-core-spacing-10) 0;
        border-bottom: 1px solid var(--joy-color-neutral-30);
        > label {
            display: block;
            margin-bottom: var(--joy-core-spacing-7);
        }
        > ul {
            @include mq.screen_sm(min) {
                column-count: 2;
            }
            @include mq.screen_md(min) {
                column-count: 3;
            }
            @include mq.screen_lg(min) {
                column-count: 4;
            }
            > li {
                margin-bottom: var(--joy-core-spacing-5);
            }
        }
        li {
            list-style-type: none;
            li a {
                font-weight: var(--joy-font-weight-normal);
            }
        }
    }
</style>
